//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate')
    .component('crl8ProgressBar', {
      bindings: {
        progress: '&progressBarProgress',
      },
      template:
            '<progress-bar-track>' +
                '<progress-bar-leader class="progress-bar-indicator" ng-style="$ctrl.leaderStyles"></progress-bar-leader>' +
                '<progress-bar-follower class="progress-bar-indicator"></progress-bar-follower>' +
            '</progress-bar-track>',
      controller: ['$element', '$scope', function($element, $scope) {
        const self = this;

        $scope.$watch('$ctrl.progress()', (progress) => {
          $element.toggleClass('progress-bar-complete', progress === 1);
          $element.toggleClass('progress-bar-failed', progress === -1);
          $element.toggleClass('progress-bar-indeterminate', progress === 'indeterminate');

          self.leaderStyles = progress === 'indeterminate' ? {} : {
            width: `${progress * 100}%`,
          };
        });
      }],
    });
})();
